import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserPolicyEvalDto } from 'src/shared/services/api.service'; // Replace with the correct path
import { PolicySetKey } from 'src/shared/constants';
import { LocalStorageService } from 'src/shared/services/local-storage.service';

@Directive({
  selector: '[componentRequiresPolicy]',
  standalone: false,
})
export class ComponentRequiresPolicyDirective {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef,
  ) {}

  @Input() set componentRequiresPolicy(policyName: keyof UserPolicyEvalDto) {
    const policySet = JSON.parse(this.localStorageService.get(PolicySetKey) ?? '{}') as UserPolicyEvalDto;
    if (policySet) {
      const result = policySet[policyName];
      if (result !== true) {
        this.viewContainerRef.clear();
      } else {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }
  }
}
